import numeral from 'numeral';

export const formatMoney = (num) => numeral(num).format('$0,0[.]00');

export const formatMoneyFixedTrailing = (num) => numeral(num).format('$0,0.00');

export const formatNumber = (num) => Number(num).toLocaleString('en');

export const formatPercentage = (num, format) => `${numeral(num).format(format || '0[.]0[0]')}%`;

export const pluralize = (count, single, plural) => {
  if (count === 1) {
    return single;
  }
  return plural != null ? plural : `${single}s`;
};

const NUMBER_WORDS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
];
export const numberToWord = (num) => {
  const rounded = Math.round(num);
  if (rounded < 0 || rounded >= 12) {
    return `${num}`;
  }
  return NUMBER_WORDS[rounded];
};

export const formatByObject = (value, obj) => {
  if (!value || !obj) return value;

  let str = value.toString();

  Object.keys(obj).forEach((key) => {
    str = str.replace(new RegExp(`\\{${key}\\}`, 'gi'), obj[key]);
  });

  return str;
};
